export var MyTripsFilter;
(function (MyTripsFilter) {
    MyTripsFilter["UPCOMING_TRIPS"] = "Upcoming trips";
    MyTripsFilter["WATCHED_TRIPS"] = "Watched trips";
    MyTripsFilter["TRAVEL_CREDITS"] = "Airline travel credits";
    MyTripsFilter["CANCELED_TRIPS"] = "Canceled trips";
    MyTripsFilter["PAST_TRIPS"] = "Past trips";
    MyTripsFilter["TRIPS_WITH_OFFERS"] = "Trips with offers";
})(MyTripsFilter || (MyTripsFilter = {}));
export var ItineraryEnum;
(function (ItineraryEnum) {
    ItineraryEnum["Flight"] = "Flight";
    ItineraryEnum["Hotel"] = "Hotel";
    ItineraryEnum["Watch"] = "Watch";
    ItineraryEnum["Car"] = "Car";
    ItineraryEnum["Home"] = "Home";
    ItineraryEnum["Package"] = "Package";
    ItineraryEnum["PackageHotel"] = "PackageHotel";
    ItineraryEnum["PackageFlight"] = "PackageFlight";
    ItineraryEnum["Experience"] = "Experience";
})(ItineraryEnum || (ItineraryEnum = {}));
export var IRequestTravelerEditFormEnum;
(function (IRequestTravelerEditFormEnum) {
    IRequestTravelerEditFormEnum["frequentFlyerNumber"] = "frequentFlyerNumber";
    IRequestTravelerEditFormEnum["tsaRedressNumber"] = "tsaRedressNumber";
    IRequestTravelerEditFormEnum["knownTravelerNumber"] = "knownTravelerNumber";
    IRequestTravelerEditFormEnum["name"] = "name";
    IRequestTravelerEditFormEnum["birthdate"] = "birthdate";
    IRequestTravelerEditFormEnum["gender"] = "gender";
    IRequestTravelerEditFormEnum["specialAssistance"] = "specialAssistance";
})(IRequestTravelerEditFormEnum || (IRequestTravelerEditFormEnum = {}));
export var MyTripsModalTypes;
(function (MyTripsModalTypes) {
    MyTripsModalTypes["ConfirmationModal"] = "ConfirmationModal";
    MyTripsModalTypes["ExchangeFlight"] = "ExchangeFlight";
    MyTripsModalTypes["PaymentModal"] = "PaymentModal";
    MyTripsModalTypes["ResendConfirmation"] = "ResendConfirmation";
    MyTripsModalTypes["SelfServeCancelFlight"] = "SelfServeCancelFlight";
    MyTripsModalTypes["TravelersModal"] = "TravelersModal";
    MyTripsModalTypes["OutboundItinerary"] = "OutboundItinerary";
    MyTripsModalTypes["MulticityItinerary0"] = "MulticityItinerary0";
    MyTripsModalTypes["MulticityItinerary1"] = "MulticityItinerary1";
    MyTripsModalTypes["MulticityItinerary2"] = "MulticityItinerary2";
    MyTripsModalTypes["MulticityItinerary3"] = "MulticityItinerary3";
    MyTripsModalTypes["MulticityItinerary4"] = "MulticityItinerary4";
    MyTripsModalTypes["ItemizedHotelReceipt"] = "ItemizedHotelReceipt";
    MyTripsModalTypes["ReturnItinerary"] = "ReturnItinerary";
    MyTripsModalTypes["FlightDisruptionAssistanceError"] = "FlightDisruptionAssistanceError";
    MyTripsModalTypes["ScheduleChange"] = "ScheduleChange";
    MyTripsModalTypes["StopWatching"] = "StopWatching";
    MyTripsModalTypes["ChangeEmail"] = "ChangeEmail";
    MyTripsModalTypes["CancelFlight"] = "CancelFlight";
    MyTripsModalTypes["RequestTravelerEdit"] = "RequestTravelerEdit";
    MyTripsModalTypes["RequestTravelerEditSuccess"] = "RequestTravelerEditSuccess";
    MyTripsModalTypes["CfarFlight"] = "CfarFlight";
    MyTripsModalTypes["ChangeFlight"] = "ChangeFlight";
    MyTripsModalTypes["CancelHotel"] = "CancelHotel";
    MyTripsModalTypes["ChangeHotel"] = "ChangeHotel";
    MyTripsModalTypes["CheckInFlight"] = "CheckInFlight";
    MyTripsModalTypes["CarConfirmation"] = "CarConfirmation";
    MyTripsModalTypes["DriversModal"] = "DriversModal";
    MyTripsModalTypes["ChangeCar"] = "ChangeCar";
    MyTripsModalTypes["CancelCar"] = "CancelCar";
    MyTripsModalTypes["PickUp"] = "PickUp";
    MyTripsModalTypes["DropOff"] = "DropOff";
    MyTripsModalTypes["BasicInfo"] = "BasicInfo";
    MyTripsModalTypes["CfarHotel"] = "CfarHotel";
    MyTripsModalTypes["CfarHotelError"] = "CfarHotelError";
    MyTripsModalTypes["CfarHotelExpired"] = "CfarHotelExpired";
    MyTripsModalTypes["VirtualInterlineMcp"] = "VirtualInterlineMcp";
    MyTripsModalTypes["CancelHome"] = "CancelHome";
    MyTripsModalTypes["ItemizedHomeReceipt"] = "ItemizedHomeReceipt";
    MyTripsModalTypes["ViewHostAndRentalDetails"] = "ViewHostAndRentalDetails";
    MyTripsModalTypes["ItemizedPackageReceipt"] = "ItemizedPackageReceipt";
    MyTripsModalTypes["CancelExperience"] = "CancelExperience";
    MyTripsModalTypes["ExperienceItinerary"] = "ExperienceItinerary";
    MyTripsModalTypes["ExperienceCancellationPolicy"] = "ExperienceCancellationPolicy";
    MyTripsModalTypes["FlightDisruptionRebookingRedirect"] = "FlightDisruptionRebookingRedirect";
    MyTripsModalTypes["ItemizedFlightReceipt"] = "ItemizedFlightReceipt";
    MyTripsModalTypes["ItemizedCarReceipt"] = "ItemizedCarReceipt";
})(MyTripsModalTypes || (MyTripsModalTypes = {}));
//# sourceMappingURL=interfaces.js.map